export default __webpack_public_path__ + "static/webRotator/svg/12bbeeb0a791f506dcd6b5be558540c5.svg";